import React, {useState} from "react";
import {Link, useHistory} from "react-router-dom";
import Firebase from "../../services/firebase";
import Recommendation from "../commons/recommendation/recommendation.compoenent";
import graphUp from "../../img/graph-up.svg"
import lightning from "../../img/lightning.svg"
import dollar from "../../img/dollar.svg"

import {
    FormContainer,
    StyledInput,
    StyledSignIn,
    StyledForm,
    StyledLabel,
    StyledFormWrapper,
    StyledLeftForm,
    StyledRightForm,
    StyledStar,
    StyledButton,
    Row,
    FixelLogo, StyledSubTitle, StyledMidBoxes, MidBox, MidBoxIcon, StyledDescription, MidBoxTitle,

} from "./signin.style";
import Spinner from "../utils/LoadingSpinner";
import {ErrorContainer, StyledTitle} from "../style/global.style";

const SignIn = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [signInSpinner, setSignInSpinner] = useState(false);
    const history = useHistory();

    const signInWithEmailAndPassword =  (event,email,password) => {
        setSignInSpinner(true);
        Firebase.signInWithEmailAndPasswordHandler(event,email, password, setError).then(function (res) {
            setSignInSpinner(false);
            if(res?.user){
                history.push('/');
            }
        })
    }

    const onChangeHandler = (event) => {
        const {name, value} = event.currentTarget;

        if(name === 'userEmail') {
            setEmail(value);
        }
        else if(name === 'userPassword'){
            setPassword(value);
        }
    };

    return (
        <StyledSignIn>
            <FixelLogo/>
            <StyledFormWrapper>
                <StyledLeftForm>
                    <FormContainer>
                        {error && <ErrorContainer className={'shake'}>{error}</ErrorContainer>}
                        <StyledTitle>Log in to your account</StyledTitle>
                        <StyledForm>
                            <StyledLabel htmlFor="userEmail">
                                Email
                                <StyledStar>*</StyledStar>
                            </StyledLabel>
                            <StyledInput
                                type="email"
                                className="my-1 p-1 w-full"
                                name="userEmail"
                                value = {email}
                                placeholder="example@email.com"
                                id="userEmail"
                                onChange = {(event) => onChangeHandler(event)}
                            />
                            <StyledLabel htmlFor="userPassword">
                                Password
                                <StyledStar>*</StyledStar>
                            </StyledLabel>
                            <StyledInput
                                type="password"
                                className="mt-1 mb-3 p-1 w-full"
                                name="userPassword"
                                value = {password}
                                placeholder="********"
                                id="userPassword"
                                onChange = {(event) => onChangeHandler(event)}
                            />
                        </StyledForm>
                        <Row>
                            <StyledButton onClick = {(event) => {signInWithEmailAndPassword(event, email, password)}}>
                                Sign in
                                {signInSpinner ? <Spinner inline={true}/> : null }
                            </StyledButton>
                        </Row>
                        <p style={ {"marginTop" : "1rem" } }>
                            Don't have an account?{" "}
                            <Link to="signup">
                                Sign up here
                            </Link>{" "}
                            <br />{" "}
                            <Link to = "password-reset">
                                Forgot Password?
                            </Link>
                        </p>
                    </FormContainer>
                </StyledLeftForm>
                <StyledRightForm>
                    <Recommendation/>
                </StyledRightForm>
            </StyledFormWrapper>
            <StyledSubTitle>
                Drive more conversions with Fixel audiences
            </StyledSubTitle>
            <StyledMidBoxes>
                <MidBox>
                    <MidBoxIcon>
                        <img src={dollar} alt={"dollar"}/>
                    </MidBoxIcon>
                    <MidBoxTitle>
                        Zero In Your <br/>
                        Remarketing
                    </MidBoxTitle>
                    <StyledDescription>
                        Supercharge your remarketing campaigns by focusing on engaged users with higher purchase intent
                    </StyledDescription>
                </MidBox>
                <MidBox>
                    <MidBoxIcon>
                        <img src={graphUp} alt={"graphUp"}/>
                    </MidBoxIcon>
                    <MidBoxTitle>
                        Scale <br/>
                        Your Lookalikes
                    </MidBoxTitle>
                    <StyledDescription>
                        Discover new high performing audience segments by using highly engaged users to seed lookalike audiences
                    </StyledDescription>
                </MidBox>
                <MidBox>
                    <MidBoxIcon>
                        <img src={lightning} alt={"lightning"}/>
                    </MidBoxIcon>
                    <MidBoxTitle>
                        One-Click <br/>
                        Integration
                    </MidBoxTitle>
                    <StyledDescription>
                        Easily integrate with you favorite ad platforms: Google Ads, Facebook Ads, Microsoft Ads and many others
                    </StyledDescription>
                </MidBox>
            </StyledMidBoxes>
        </StyledSignIn>
    );
};
export default React.memo(SignIn);
